import "./EmailNotFoundStep.less";

import React, { Component } from "react";
import { translate } from "react-i18next";

import StepContainer from "../StepContainer/StepContainer";
import ScoodleAccountTile from "../../ScoodleAccountTile/ScoodleAccountTile";
import SuperdogInfo from "../../WizardSteps/SuperdogInfo/SuperdogInfo";
import config from "../../../config";
import queryString from "query-string";
import $ from "jquery";

const Steps = {
	NO_THIRD_PARTY_EMAIL_FORM: "NO_THIRD_PARTY_EMAIL_FORM",
	EMAIL_VERIFICATION: "EMAIL_VERIFICATION"
};

class EmailNotFoundStep extends Component {
	state = {
		step: Steps.NO_THIRD_PARTY_EMAIL_FORM,
		email: ""
	};

	constructor() {
		super();

        const currentQuery = queryString.parse(window.location.search);
        const id_token = config.user ? config.user.id_token : null;

		$.ajax({
			url: config.identityServer.baseUrl + "/Portal/SetEmailCheckAuth",
            data: {
                clientId: currentQuery.clientId || config.identityServer.clientId
			},
			headers: {
				'Authorization': 'Bearer ' + id_token
            },
			success: result => {
				if (result.success) {
					this.setState({ checked: true });
				}
				else {
					window.location = '/';
				}
			}
		})
		.fail(() => {
			window.location = '/';
		});
	}

	render() {
		const t = this.props.t;

		if (!this.state.checked) return <div/>;

		return (
				<StepContainer>
					<div>
						<h1>{t("logIn")}</h1>
						{this.state.step === Steps.NO_THIRD_PARTY_EMAIL_FORM ? this.renderNoThirdPartyEmailForm() : this.renderEmailVerification()}
					</div>
				</StepContainer>
		);
	}

	renderNoThirdPartyEmailForm() {
		const t = this.props.t;

		return (
			<div className="no-third-party-email">
				<ScoodleAccountTile />
				<p className="description">{t("noEmailDescription")}</p>
				<input type="email" placeholder={t("emailAddressPlaceholder")} value={this.state.email} onChange={this.handleEmailInputChange} />
				{this.state.showError && <p className="error">{this.state.errorMessage}</p>}
				<button className="primarybtn" onClick={this.handleContinueButtonClick}>{t("continueButton")}</button>
			</div>
		);
	}

	renderEmailVerification() {
		const t = this.props.t;

		return <SuperdogInfo description={t("verificationDescription")} />;
	}

	handleEmailInputChange = event => {
		this.setState({ email: event.target.value });
	};

	handleContinueButtonClick = () => {
		const t = this.props.t;

		if ((this.state.email || '').trim().length === 0) {
			this.setState({ showError: true, errorMessage: t('emailAddressRequired') });
			return;
		}		
		
		this.setState({ showError: false, errorMessage: '' });

		const currentQuery = queryString.parse(window.location.search);
		const returnUrl = currentQuery.returnUrl;
        const id_token = config.user ? config.user.id_token : null;

		$.ajax({
			url: config.identityServer.baseUrl + "/Portal/SetEmailConfirmAuth",
			method: 'POST',
			data: {
				email: this.state.email,
				clientId: currentQuery.clientId || config.identityServer.clientId,
				culture: config.language + "-BE",
				returnUrl: returnUrl
			},
            headers: {
                'Authorization': 'Bearer ' + id_token
            },
			success: result => {
				if (!result.success) {
					this.setState({ showError: true, errorMessage: t(result.errorCode) });
				}
				else {
					this.setState({ step: Steps.EMAIL_VERIFICATION });
				}
			}
		})
		.fail(() => {
			this.setState({ showError: true, errorMessage: t('unexpectedError') });
		});
	};
}

export default translate("emailNotFound")(EmailNotFoundStep);



// WEBPACK FOOTER //
// ./src/components/Steps/EmailNotFoundStep/EmailNotFoundStep.js